export default class VideoOverlay extends HTMLElement {

  constructor() {
    super()

    this.classList.add('video-player__overlay')
  }

}
